<template>
  <header class="header">
    <div class="logo">
      <router-link to="/homepage">
        <img src="@/assets/finaleslogo.png" alt="Logo" />
      </router-link>
    </div>
    <nav class="nav">
      <router-link to="/fortschritt" active-class="active-link">Fortschritt</router-link>
      <router-link to="/projekte" active-class="active-link">Projekte</router-link>
      <router-link to="/betreuer" active-class="active-link">Betreuer</router-link>
      <router-link to="/archiv" active-class="active-link">Archiv</router-link>
    </nav>
    <div class="hamburger-container" @click="toggleDropdown">
      <div class="hamburger">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div v-if="isDropdownOpen" class="dropdown-menu">
        <div class="user-info">
          <div class="user-name">
            Name: {{ cn }}
          </div>
          <div class="user-role">
            Rolle: {{ rolle }}
          </div>
        </div>
        <button @click="logout">Ausloggen</button>
      </div>
    </div>
  </header>
</template>

<script>
import { useAuthenticationStore } from '@/stores/useAuthStore'

export default {
  name: 'Header',
  data() {
    return {
      isDropdownOpen: false
    }
  },
  computed: {
    cn() {
      return useAuthenticationStore().cn
    },
    rolle() {
      return useAuthenticationStore().highestRoleFormatted
    }
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    async logout() {
      try {
        const response = await fetch(`${process.env.VUE_APP_BACKEND}/auth/logout`, {
          method: "POST",
          credentials: "include"
        })
        if (response.ok) {
          useAuthenticationStore().logout()
          this.$router.push({ path: "/" })
        } else {
          console.error("Logout fehlgeschlagen:", response.status)
        }
      } catch (error) {
        console.error("Fehler beim Logout:", error)
      }
    },
    closeDropdown(event) {
      if (!this.$el.contains(event.target)) {
        this.isDropdownOpen = false
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdown)
  }
}
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 40px;
  background-color: white;
  box-shadow: 0 17px 30px rgba(0, 0, 0, 0.1);
}

.logo img {
  width: 55px;
  height: 58px;
}

.nav a {
  margin: 0 15px;
  text-decoration: none;
  color: #000;
  font-weight: 500;
  position: relative;
  transition: color 0.3s ease;
}

.nav a::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 0;
  height: 2px;
  background-color: transparent;
  transition: width 0.3s ease, background-color 0.3s ease;
}

.nav a:hover {
  color: #2300ff;
}

::v-deep .active-link {
  color: #2300ff;
  position: relative;
}

::v-deep .active-link::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 100%;
  height: 2px;
  background-color: #2300ff;
}

.hamburger-container {
  position: relative;
}

.hamburger {
  min-width: 45px;
  max-width: 45px;
  height: 39px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.hamburger span {
  display: block;
  width: 100%;
  height: 5px;
  background-color: black;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.dropdown-menu {
  position: absolute;
  top: 50px;
  right: 0;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  font-family: 'DM SANS', sans-serif;
  min-width: 150px;
  white-space: nowrap;
  padding: 10px 0;
}

.user-info {
  padding: 10px 20px;
  font-size: 16px;
  color: #000;
  border-bottom: 1px solid #ddd;
  font-family: 'DM SANS', sans-serif;
}

.user-name {
  margin-bottom: 4px;
}

.dropdown-menu button {
  background: none;
  border: none;
  padding: 10px 20px;
  width: 100%;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  color: #000;
  font-family: 'DM SANS', sans-serif;
}

.dropdown-menu button:hover {
  background-color: #f0f0f0;
  color: #2300ff;
}

@media (max-width: 600px) {
  .header {
    height: 70px;
  }
}
</style>